import * as FeedbackApiUtil from "../../util/feedback_util";

export const RECEIVE_ALL_FEEDBACK = "RECEIVE_ALL_FEEDBACK";
export const RECEIVE_FEEDBACK = "RECEIVE_FEEDBACK";

const receiveAllFeedback = (allFeedback) => {
    return {
        type: RECEIVE_ALL_FEEDBACK,
        allFeedback
    }
}

const receiveFeedback = feedback => {
    return {
        type: RECEIVE_FEEDBACK,
        feedback
    }
};

export const fetchAllFeedback = (cancelToken) => dispatch => {
    return FeedbackApiUtil.fetchAllFeedback(cancelToken)
        .then(allFeedback => { dispatch(receiveAllFeedback(allFeedback)) })
};


export const createFeedback = feedback => dispatch => {
    return FeedbackApiUtil.createFeedback(feedback)
        .then(feedback => { 
            dispatch(receiveFeedback(feedback.data))
        })
};
